import { GenericType } from "@/types";
import { jwtDecode } from "jwt-decode";

export const setToken = (token: string) => localStorage.setItem("token", token);
export const getToken = () => localStorage.getItem("token");
export const removeToken = () => {
  // localStorage.clear();
  localStorage.removeItem("token");
  sessionStorage.clear();
  Object.keys(localStorage).forEach((key) => {
    if (key.endsWith("-page")) {
      localStorage.removeItem(key);
    }
    if (key.endsWith("-perPage")) {
      localStorage.removeItem(key);
    }
  });
};
export const getUserInfo = (): GenericType => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    const decoded = jwtDecode(token);
    return decoded;
  } catch (error) {
    removeToken();
    window.location.href = "/login";
    console.log(error);
    return null;
  }
};
